import {Component, Input} from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {NgIf} from "@angular/common";
import {UiCardComponent} from "../../../ui-utils/components/ui-card/ui-card.component";
import {User} from "../../../interfaces/user";
import {TrafficPacksService} from "../../services/traffic-packs.service";
import {DashboardService} from "../../services/dashboard.service";
import {CommonService} from "../../../services/common.service";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store/app-state";
import {Title} from "@angular/platform-browser";
import {DialogService} from "primeng/dynamicdialog";
import {MessageService} from "primeng/api";
import {DashboardSubscriptionsModel} from "../../models/dashboardSubscriptionsModel";
import {BehaviorSubject} from "rxjs";
import {ChangePasswordComponent} from "../change-password/change-password.component";

@Component({
  selector: 'app-account',
  standalone: true,
  imports: [
    ButtonDirective,
    NgIf,
    UiCardComponent
  ],
  templateUrl: './account.component.html',
  styleUrl: './account.component.less'
})
export class AccountComponent {
  @Input() user: User | null;
  @Input() voluntaryBlocking = false;
  @Input() clientIp?: string | null;
  dashboardSubscriptionsModel: DashboardSubscriptionsModel;
  listInitializer: BehaviorSubject<DashboardSubscriptionsModel>;

  constructor(private trafficPacksService: TrafficPacksService,
              private dashboardService: DashboardService,
              private commonService: CommonService,
              private store: Store<{ app: AppState }>,
              private titleService: Title,
              private dialogService: DialogService,
              private messageService: MessageService) {
    this.dashboardSubscriptionsModel = new DashboardSubscriptionsModel();
    this.listInitializer = new BehaviorSubject(this.dashboardSubscriptionsModel);
  }

  coaAuth(): void {
    this.dashboardService.authlog().subscribe(data => {
      if (data.error === 'OK') {
        this.messageService.add({
          severity: 'success',
          summary: 'Авторизация прошла успешно',
          detail: data.error,
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: data.error,
        });
      }
    });
  }
  showChangePasswordDialog(): void {
    this.dialogService.open(ChangePasswordComponent, {
      header: 'Смена пароля',
      closable: true,
      modal: true,
      width: '400px',
    });
  }

}
